<template>
    <ul class="mt-1">
        <li
            class="font-bold mb-1"
            v-for="(item, index) in questions" :key="index"
        >
            <p
                class="rounded-md p-2 flex items-center cursor-pointer transition duration-300"
                :class="{
                    ['bg-gray-900 text-gray-200'] : open == index,
                    ['bg-gray-100 hover:bg-gray-200 text-gray-900'] : open != index
                }"
                @click="openAnswer(item, index)"
            >
            <span
                class="text-2xl mr-2 rounded-md px-1 transition duration-300"
                :class="{
                    ['bg-red-700 text-gray-200'] : open == index,
                    ['text-red-700'] : open != index
                }"
            >{{ (index + 1) + '.'}}</span>
            {{ item.question }}</p>

                <div
                    class="whitespace-pre-line font-normal py-4 px-2 overflow-hidden"
                    :ref="el => { answer = el }"
                    v-if="open == index"
                    v-html="item.answer"
                ></div>
        </li>
    </ul>
</template>

<script>
import { ref } from '@vue/reactivity'
export default {
    props: ['questions'],

    setup(props) {
        const answer = ref(null);
        const open = ref(null);

        function openAnswer(item, key){
            open.value = key;
        }

        return {
            answer,
            open,

            openAnswer
        }
    }
}
</script>

<style>

</style>
